<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="table"/>
      <template v-else>
        <v-col v-if="!subscriptionsList.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-autorenew</v-icon>
          <span class="d-block subtitle-1">No existen suscripciones</span>
          <v-btn class="my-5" v-if="showCreate" :to="{name: 'SubscriptionCreate'}" outlined>Crear una suscripción</v-btn>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="subscriptionsList" hide-default-footer :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint @click:row="(subscriptionsList) => {$router.push(`/subscriptions/${subscriptionsList.id}`)}" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.customer__name`]="{ item }">
              <span class="text--secondary font-weight-medium">{{item.customer.name}}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div class="text-right">
                <v-chip v-if="item.status === 'active'" color="lightBlue" text-color="primary" small>Activo <v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'paused'" color="defaultGrey" text-color="secondary" small>Pausado<v-icon class="ml-1" x-small>mdi-pause</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'cancelled'" color="defaultGrey" text-color="secondary" small>Cancelado<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'finalized'" color="defaultGrey" text-color="secondary" small>Finalizado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'needs_attention'" color="defaultGrey" text-color="secondary" small>Necesita atención<v-icon class="ml-1" x-small>mdi-clock-outline</v-icon></v-chip>
              </div>
            </template>
            <template v-slot:[`item.plans`]="{ item }">
              <v-menu open-on-hover right offset-x transition="slide-x-transition" :nudge-width="140">
                <template v-slot:activator="{on}">
                  <div v-on="on">
                    <template v-for="(p, i) in item.lines.slice(0, 2)">
                      <span :key="p.id">{{p.plan.name}}</span>
                      <template v-if="item.lines.length > 1 && i < 1">, </template>
                    </template>
                    <span v-if="item.lines.length > 2">y otros {{item.lines.length - 2}} planes</span>
                  </div>
                </template>
                <v-card class="pa-0">
                  <v-subheader class="font-weight-medium background">Productos</v-subheader>
                  <v-card-text class="py-0">
                    <v-list-item class="pa-0" v-for="p in item.lines" :key="p.id">
                      <v-list-item-content>
                        <v-list-item-title>{{p.plan.name}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" :ripple="false" text :to="{name: 'SubscriptionRetrieve', params: {id: item.id}}">Ver detalle <v-icon small>mdi-arrow-right</v-icon></v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
            <template v-slot:[`item.next_billing`]="{ item }">
              <span class="text--secondary font-weight-medium" v-if="['active', 'needs_attention'].includes(item.status)">{{ item.next_billing | date }}</span>
              <span v-else>---</span>
            </template>
            <template v-slot:[`item.created`]="{ item }">
              <span>{{item.created | date}}</span>
            </template>
          </v-data-table>
           <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'SubscriptionList', query: showCriteria}" outlined color="secondary">Ver todas las suscripciones</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary" v-if="$route.name !== 'AccountExportSubscription'">{{count}} registros</span>
                  <span class="body-2 text--secondary" v-else>{{count}} resultados encontrados</span>
                </v-col>
                <v-col cols="6" class="text-right" v-if="$route.name !== 'AccountExportSubscription'">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'customer__name', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'status' },
      { text: 'Productos', value: 'plans' },
      { text: 'Próxima facturación', value: 'next_billing', width: 300, align: 'end', sortable: true },
      { text: 'Creado el', value: 'created', width: 200, align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.subscriptions.subscriptionsCount,
    subscriptionsList: state => state.subscriptions.subscriptionsList
  }),
  methods: {
    computeTieredLineTotal (line) {
      const tier = line.plan.tiers.find((t) => (t.quantity_from <= line.quantity && t.quantity_to >= line.quantity) || (t.quantity_from <= line.quantity && t.quantity_to === null))
      return tier.amount * line.quantity
    }
  }
}
</script>
